<template>
  <div>
    <b-tabs
      active-tab-class="active-tab"
      align="center"
      content-class="mt-3"
    >
      <b-tab
        title="Azure Cost"
      >
        <div
          id="costReportEmbedContainer"
          ref="costReportEmbedContainer"
          style="width: 100%; height: 50vw"
        />
      </b-tab>
      <b-tab
        title="Kubernetes Cost"
      >
        <div
          id="kubeCostReportEmbedContainer"
          ref="kubeCostReportEmbedContainer"
          style="width: 100%; height: 50vw"
        />
      </b-tab>
      <b-tab
        title="Kubernetes Usage"
      >
        <div
          id="kubeUsageReportEmbedContainer"
          ref="kubeUsageReportEmbedContainer"
          style="width: 100%; height: 50vw"
        />
      </b-tab>
      <b-tab
        title="Azure Projects via CIE Portal"
      >
        <div
          id="cieCostReportEmbedContainer"
          ref="cieCostReportEmbedContainer"
          style="width: 100%; height: 50vw"
        />
      </b-tab>
      <b-tab
        title="MSI MoM Analysis"
      >
        <div
          id="msiMoMReportEmbedContainer"
          ref="msiMoMReportEmbedContainer"
          style="width: 100%; height: 50vw"
        />
      </b-tab>
      <b-tab
        title="Azure Historical data"
      >
        <div
          id="msiAzureHistoricalEmbedContainer"
          ref="msiAzureHistoricalEmbedContainer"
          style="width: 100%; height: 50vw"
        />
      </b-tab>
      <b-tab
        title="Licenses"
      >
        <div
          id="msiLicensesEmbedContainer"
          ref="msiLicensesEmbedContainer"
          style="width: 100%; height: 50vw"
        />
      </b-tab>
      <b-tab
        title="CIE AWS Cost"
      >
        <div
          id="msiAWSCostEmbedContainer"
          ref="msiAWSCostEmbedContainer"
          style="width: 100%; height: 50vw"
        />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import api from '@/api';
import Vue from 'vue';
import * as pbi from 'powerbi-client';
/* global powerbi*/
Vue.use(pbi);
/**
 * Embeds a PowerBI report in the specified container
 * @param {string} reportId - id of report in PowerBi
 * @param {string} groupId - id of group in PowerBi
 * @param {div} container - div container to put iframe in
 */
async function embedReport (reportId, groupId, container) {
  const body = {
    reportId,
    data: {
      accessLevel: 'View',
    },
  };
  const embedToken = await api.getEmbedTokenInGroup(body);
  const config = {
    type: 'report',
    tokenType: pbi.models.TokenType.Embed,
    accessToken: embedToken,
    embedUrl:
      `https://app.powerbi.com/reportEmbed?reportId=${reportId}&groupId=${groupId}`,
    id: reportId,
    permissions: pbi.models.Permissions.Read,
    settings: {
      panes: {
        filters: {
          visible: true,
        },
        pageNavigation: {
          visible: true,
        },
      },
      hideErrors: false,
    },
  };

  powerbi.embed(container, config);
}
export default {
  mounted() {
    this.$nextTick(async () => {
      try {
        const azureCostReportId = '239a7a2b-c8a2-4609-96ef-5d80037d51e4';
        const kubeCostReportId = '98a39735-2159-45a2-a7eb-58eca5f199c7';
        const kubeUsageReportId = '281fa705-1f89-4962-a38b-997452bf73a2';
        const cieCostReportId = '116e50e8-ec8b-41fb-bd55-22aca6023378';
        const msiMoMReportId = 'f49a2f97-1e30-41ee-8ad3-9ace358301d6';
        const azureHistoricalId = '2d52e382-5f9e-455b-beed-ca639192ae3a';
        const licencesId = 'a785c6d6-e5ea-4f76-b4da-8be5cff1ae12';
        const awsCostId = '52e3924d-af07-4c99-a702-03aa631d8487';
        const groupId = 'f14dc5a6-1669-4eb5-a66f-64342aa6858e';
        await embedReport(azureCostReportId, groupId, this.$refs['costReportEmbedContainer']);
        await embedReport(kubeCostReportId, groupId, this.$refs['kubeCostReportEmbedContainer']);
        await embedReport(kubeUsageReportId, groupId, this.$refs['kubeUsageReportEmbedContainer']);
        await embedReport(cieCostReportId, groupId, this.$refs['cieCostReportEmbedContainer']);
        await embedReport(msiMoMReportId, groupId, this.$refs['msiMoMReportEmbedContainer']);
        await embedReport(azureHistoricalId, groupId, this.$refs['msiAzureHistoricalEmbedContainer']);
        await embedReport(licencesId, groupId, this.$refs['msiLicensesEmbedContainer']);
        await embedReport(awsCostId, groupId, this.$refs['msiAWSCostEmbedContainer']);
      } catch (error) {
        console.log(error);
      }
    });
  },
};
</script>
